const unleashKey = import.meta.env.VITE_UNLEASH_KEY;
const isCypress = import.meta.env.MODE === "cypress";

const isStartUnleashClient = Boolean(unleashKey) && !isCypress;

export { isStartUnleashClient };
